import { IApplicationState } from '../../types/redux';

export function getGenplanSelector(state: IApplicationState) {
  return state.newbuilding.genplan;
}
